module.exports = __webpack_public_path__ + "img/3.25bb5564.jpg";